import { render, staticRenderFns } from "./MultiLangSelector.vue?vue&type=template&id=3a96f3bc"
import script from "./MultiLangSelector.vue?vue&type=script&lang=js"
export * from "./MultiLangSelector.vue?vue&type=script&lang=js"
import style0 from "./MultiLangSelector.vue?vue&type=style&index=0&id=3a96f3bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports